import Marquee from "react-fast-marquee";

const words = [
  "Deal Flow",
  "Operational Alpha",
  "AI & GenAI",
  "Cybersecurity",
  "Governance",
  "Next-Gen Alignment",
  "ESG & Impact",
  "Technology Diligence",
  "Strategic Finance",
];

export default function EditorialMarquee() {
  return (
    <section
      className="relative border-y border-[var(--line)] py-8 md:py-10 bg-ink-2 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="grain absolute inset-0" />
      <Marquee speed={30} gradient={false} pauseOnHover>
        <div className="marquee-track">
          {words.concat(words).map((w, i) => (
            <span
              key={i}
              className="flex items-center gap-6 font-display text-3xl md:text-5xl text-ivory/70"
            >
              <span>{w}</span>
              <span className="text-gold text-2xl">✦</span>
            </span>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
